export default {
  title: 'Alérgenos',
  options: {
    dairy: 'Lácteos/Leche',
    eggs: 'Huevos',
    fish: 'Pescado',
    gluten: 'Gluten',
    mango: 'Mango',
    peanuts: 'Cacahuetes',
    sesame: 'Sésamo',
    shellfish: 'Marisco',
    soy: 'Soja',
    tree_nuts: 'Frutos de cáscara',
    celery: 'Apio',
    crustaceans: 'Crustáceos',
    lupin: 'Altramuz',
    molluscs: 'Moluscos',
    mustard: 'Mostaza',
    nuts: 'Frutos secos',
    sulphites: 'Sulfitos',
    almonds: 'Almendras',
    barley: 'Cebada',
    brazil_nuts: 'Nueces de Brasil',
    cashew: 'Anacardos',
    hazelnuts: 'Avellanas',
    kamut: 'Kamut',
    macadamia: 'Nueces de macadamia',
    oats: 'Avena',
    pecan: 'Pacanas',
    pistachios: 'Pistachos',
    rye: 'Centeno',
    spelt: 'Espelta',
    walnuts: 'Nueces',
    wheat: 'Trigo',
    sugared_drink: 'Bebida azucarada',
    lentils: 'Lentejas',
    queensland_nuts: 'Nueces de Queensland',
  },
};
